// ToastProvider.jsx
import React, { createContext, useContext, useState, useCallback } from "react";
import * as Toast from "@radix-ui/react-toast";
import "./toast.scss";

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [toastData, setToastData] = useState({
    title: "",
    description: "",
  });

  const showToast = useCallback(({ title, description }) => {
    setToastData({ title, description });
    setOpen(false); // Reset if needed
    requestAnimationFrame(() => setOpen(true)); // Ensure animation works properly
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      <Toast.Provider swipeDirection="right">
        <Toast.Root className="toast-root" open={open} onOpenChange={setOpen}>
          <Toast.Title className="toast-title">{toastData.title}</Toast.Title>
          <Toast.Description className="toast-description">
            {toastData.description}
          </Toast.Description>
          <Toast.Action className="toast-action" asChild altText="Close">
            <button className="close-toast-btn">Close</button>
          </Toast.Action>
        </Toast.Root>

        <Toast.Viewport className="toast-viewport" />
      </Toast.Provider>
    </ToastContext.Provider>
  );
};
